import { render } from "./ReportsAgents.vue?vue&type=template&id=cb46da7c"
import script from "./ReportsAgents.vue?vue&type=script&lang=js"
export * from "./ReportsAgents.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__